import { ElementRef, Injector, Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { delay, identity, of, switchMap } from 'rxjs';

/**
 * Return a signal that is true when the input signal is true, or was true recently.
 *
 * More specifically, “recently” means the length of time it takes to animate the closure of a modal.
 * This can be used to conditionally render a modal’s content when the modal is visible.
 *
 * This is equivalent to a monostable multivibrator.
 */
export function modalOpenOrClosing(
  open: Signal<boolean>,
  el: Signal<ElementRef<HTMLElement>>,
  injector?: Injector,
): Signal<boolean> {
  const closeDuration = () => {
    const style = getComputedStyle(el().nativeElement);

    return parseInt(style.getPropertyValue('--ds-modal-animation-duration').trim(), 10) || 0;
  };

  return toSignal(
    toObservable(open).pipe(switchMap((isOpen) => of(isOpen).pipe(isOpen ? identity : delay(closeDuration())))),
    { injector, initialValue: open() },
  );
}
